import { motion } from 'framer-motion';
import { useParams } from 'react-router';
import history from '../../../../browserHistory';
import { CandidateCard } from './CandidateCard';

export const CandidateSelection = ({ allCandidates = [], candidates = [] }) => {
  const { jobId, candidateId } = useParams();

  // Navigation only — the candidate_viewed event is fired from a single source
  // (ConfirmCandidate's effect on candidate change) to avoid a double fire.
  const handleOnClick = (id) => {
    history.replace(`/dashboard/job/${jobId}/confirm/${id}`);
  };

  if (allCandidates?.length <= 1) {
    return null;
  }

  return (
    <div
      style={{
        position: 'relative',
        alignItems: 'center',
        display: 'flex',
        width: '100%',
        gap: 8,
      }}
    >
      {candidates?.map((item) => (
        <motion.div
          key={item.id}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          style={{ flex: 1, maxWidth: '20%' }}
        >
          <CandidateCard
            item={item}
            isSelected={candidateId === item?.candidate?.id}
            onClick={() => handleOnClick(item?.candidate?.id)}
            isBestPick={false}
            containerStyle={{ width: '100%' }}
          />
        </motion.div>
      ))}
    </div>
  );
};
